import {connect} from "react-redux";
import {getAlLThis} from "../store/documents";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useEffect, useRef, useState, useCallback} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import ReactPaginate from "react-paginate";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Button from "@mui/material/Button";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import EditDocument from "./editDocument";
import uzb_flag from "../uzbekistan.png"
import china_flag from "../chinas.png"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScanDocument from "../blocks/scanDocument";
import { Card, CardContent, Typography, Grid, Chip, Alert, CircularProgress } from "@mui/material";
import PaymentIcon from '@mui/icons-material/Payment';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InfoIcon from '@mui/icons-material/Info';
import axios from 'axios';

function OneDoc(props) {
    const navigate = useNavigate()
    const params = useParams()
    const [searchParams] = useSearchParams()
    const trackType = searchParams.get('type')

    const [documents, setDocuments] = useState([])
    const [open, setOpen] = useState(false)
    const [openScanNow, setOpenScanNow] = useState(false)
    const [scanTrack, setScanTrack] = useState([])
    const [notFound, setNotFound] = useState(false)
    const [openItem, setOpenItem] = useState(false)
    const [openScanNowItem, setOpenScanNowItem] = useState(false)
    const [scannedCodes, setScannedCodes] = useState(new Set())

    // New states for payment status, delivery info, and client orders
    const [paymentInfo, setPaymentInfo] = useState(null)
    const [deliveryInfo, setDeliveryInfo] = useState(null)
    const [clientOrders, setClientOrders] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    // Add flag to prevent auto-opening modal multiple times
    const hasAutoOpened = useRef(false)

    // Function to fetch payment status, delivery info, and unpaid orders
    const fetchClientInfo = useCallback(async (clientCode) => {
        if (!clientCode) return;

        setLoading(true);
        setError(null);

        try {
            // Fetch unpaid orders for the client
            const ordersResponse = await axios.get(`https://fx.softmakon.uz/api/v1/client-orders/`, {
                params: { client_id: clientCode }
            });
            setClientOrders(ordersResponse.data);

            // Fetch delivery info for the client
            try {
                const deliveryResponse = await axios.get(`https://fx.softmakon.uz/api/delivery-info/`, {
                    params: { client_id: clientCode }
                });
                console.log(deliveryResponse.data, "deliveryinfo")
                setDeliveryInfo(deliveryResponse.data.length > 0 ? deliveryResponse.data[0] : null);
            } catch (deliveryError) {
                console.log('No delivery info found for client:', clientCode);
                setDeliveryInfo(null);
            }

            // You can add more API calls here if needed for payment status
            // For example, if you have a separate payment status endpoint

        } catch (error) {
            console.error('Error fetching client info:', error);
            setError('Error loading client information');
            setClientOrders(null);
            setDeliveryInfo(null);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchTrackingDataByType = useCallback(async () => {
        try {
            let response;
            if (trackType === 'avia') {
                response = await axios.get('https://fx.softmakon.uz/api/combined-tracking/', {
                    params: {
                        type: 'avia',
                        getall: `${params['part']},${params['code']}`
                    }
                });
            } else if (trackType === 'fura') {
                response = await axios.get('https://fx.softmakon.uz/api/combined-tracking/', {
                    params: {
                        type: 'fura',
                        getall: `${params['part']},${params['code']}`
                    }
                });
            } else if (trackType === 'avia_tracking') {
                response = await axios.get('https://fx.softmakon.uz/api/combined-tracking/', {
                    params: {
                        type: 'avia_tracking',
                        getall: `${params['part']},${params['code']}`
                    }
                });
            } else {
                const data = {
                    "part": params['part'],
                    "code": params['code'],
                    "type": trackType
                }
                props.getAlLThis(data)
                return;
            }

            const trackingResult = response.data;

            const normalizedData = trackingResult.map(item => {
                if (trackType === 'fura') {
                    return {
                        code: item.clientCode,
                        serial_number: item.serial_number,
                        track_code: item.trackingNumber,
                        place: item.location,
                        create_date: item.createdAt,
                        type: trackType,
                        weight: item.weight,
                        status: item.status,
                        confirmed: item.confirmed,
                        boxId: item.boxId,
                        all_sum: item.all_sum,
                        already_come: item.already_come
                    };
                } else if (trackType === 'avia_tracking') {
                    return {
                        code: item.clientCode,
                        serial_number: item.serial_number,
                        track_code: item.trackingNumber,
                        place: item.location || 'china',
                        create_date: item.createdAt,
                        type: trackType,
                        weight: item.weight,
                        status: item.status,
                        confirmed: item.confirmed,
                        box_number: item.box_number,
                        product_title: item.product_title,
                        all_sum: item.all_sum,
                    };
                } else {
                    // avia
                    return {
                        code: item.code,
                        serial_number: item.serial_number,
                        track_code: item.track_code,
                        place: item.place,
                        create_date: item.create_date,
                        type: trackType,
                        weight: item.weight,
                        status: item.status,
                        confirmed: item.confirmed,
                        boxId: item.boxId,
                        all_sum: item.all_sum,
                        already_come: item.already_come
                    };
                }
            });

            setDocuments(normalizedData);

            // Fetch client information for the first document's client code
            if (normalizedData.length > 0) {
                fetchClientInfo(normalizedData[0].code);
            }

        } catch (error) {
            console.error('Error fetching tracking data:', error);
        }
    }, [trackType, params, fetchClientInfo]);

    // Initial load effect
    useEffect(() => {
        if (trackType) {
            fetchTrackingDataByType();
        } else {
            const data = {
                "part": params['part'],
                "code": params['code'],
                "type": trackType
            }
            props.getAlLThis(data)

            // Fetch client info for non-tracking type as well
            fetchClientInfo(params['code']);
        }

        function KeyCheck(event) {
            var KeyID = event.keyCode;
            if (KeyID === 8) {
                navigate('/documents/' + params['part'] + "/?" + trackType)
            }
        }
        document.addEventListener("keydown", KeyCheck);

        return () => document.removeEventListener("keydown", KeyCheck);
    }, [trackType, params, fetchTrackingDataByType, navigate, props, fetchClientInfo]);

    // Separate effect for refreshing data when modals close
    useEffect(() => {
        if (!open && !openScanNow) {
            // Kichik kechikish — DB yozuvi tugashini kutamiz
            const timer = setTimeout(() => {
                if (trackType) {
                    fetchTrackingDataByType();
                } else {
                    const data = {
                        "part": params['part'],
                        "code": params['code'],
                        "type": trackType
                    }
                    props.getAlLThis(data)
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [open, openScanNow]);

    // Process documents and set scan tracking
    useEffect(() => {
        let processedDocs;

        if (trackType) {
            processedDocs = documents;
        } else {
            processedDocs = props.documents;
            const this_doc = props.documents.filter(item => item.code !== params['code'])
            if (!this_doc.length) {
                processedDocs = props.documents
            }
        }

        if (!trackType && JSON.stringify(processedDocs) !== JSON.stringify(documents)) {
            setDocuments(processedDocs);
        }

        const docs = processedDocs.filter(item => item.place === 'china')
        setNotFound(docs.length === 0);

        let result = Object.values(processedDocs.reduce((hash, item) => {
            if (!hash[item.code]) {
                hash[item.code] = {code: item.code, uzb: [], ontheway: [], china: []};
            }
            if (item.place == 'uzb') {
                hash[item.code].uzb.push(item.place);
            } else if (item.place == 'ontheway') {
                hash[item.code].ontheway.push(item.place);
            }
            else {
                hash[item.code].china.push(item.place);
            }
            return hash;
        }, {}));
        setScanTrack(result);

    }, [props.documents, documents, trackType, params]);

    // Auto-open edit modal
    useEffect(() => {
        const processedDocs = trackType ? documents : props.documents;
        const docs = processedDocs.filter(item => item.code === params['code']).filter(item => item.place === 'china')

        if (docs.length && !open && !hasAutoOpened.current) {
            hasAutoOpened.current = true;
            setOpen(true)
            const data = {
                "part": params['part'],
                "code": params['code'],
                "type": trackType
            }
            setOpenItem(data)
        }

        if (!docs.length) {
            hasAutoOpened.current = false;
        }
    }, [documents, props.documents, trackType, params, open]);

    // Payment Status Component
    const PaymentStatusCard = () => (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PaymentIcon sx={{ mr: 1 }} />
                    To'lov holati
                </Typography>
                {loading ? (
                    <CircularProgress size={24} />
                ) : error ? (
                    <Alert severity="error">{error}</Alert>
                ) : clientOrders ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="text.secondary">
                                Mijoz ID: <strong>{clientOrders.client_id}</strong>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="text.secondary">
                                Jami to'lanmagan: <strong style={{color: clientOrders.total_unpaid > 0 ? '#f44336' : '#4caf50'}}>
                                {clientOrders.total_unpaid?.toLocaleString()} so'm
                            </strong>
                            </Typography>
                        </Grid>
                        {clientOrders.orders && clientOrders.orders.length > 0 && (
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>
                                    Buyurtmalar bo'yicha:
                                </Typography>
                                {clientOrders.orders.map((order, index) => (
                                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                    <span>
                                        <Chip
                                            size="small"
                                            label={
                                                order.type === 'avia' ? 'Avia' :
                                                    order.type === 'avia_tracking' ? 'Avia Tracking' :
                                                        'Fura'
                                            }
                                            color={
                                                order.type === 'avia' ? 'primary' :
                                                    order.type === 'avia_tracking' ? 'warning' :
                                                        'success'
                                            }
                                            sx={{ mr: 1 }}
                                        />
                                        Partiya: {order.serial_number}
                                        {order.location === 'ontheway' && (
                                            <span style={{ marginLeft: '8px', color: '#2196f3', fontSize: '0.875rem' }}>
                                                (yetkazib berilgan)
                                            </span>
                                        )}
                                    </span>
                                        <span style={{color: order.not_paid > 0 ? '#f44336' : '#4caf50'}}>
                                        {order.not_paid?.toLocaleString()} so'm
                                    </span>
                                    </div>
                                ))}
                            </Grid>
                        )}
                    </Grid>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        To'lov ma'lumotlari topilmadi
                    </Typography>
                )}
            </CardContent>
        </Card>
    );

    // Delivery Info Component
    const DeliveryInfoCard = () => (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', mb: 2,
                    justifyContent: "flex-end" }}>
                    <LocalShippingIcon sx={{ mr: 1 }} />
                    Yetkazib berish ma'lumotlari
                </Typography>
                {loading ? (
                    <CircularProgress size={24} />
                ) : deliveryInfo ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="body2" color="text.secondary" style={{textAlign: 'right'}}>
                                Yetkazib berish turi: <strong>{deliveryInfo.type || 'Belgilanmagan'}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Yetkazib berish ma'lumotlari topilmadi
                    </Typography>
                )}
            </CardContent>
        </Card>
    );

    // Pagination
    let pageItems = documents

    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0);

    const endOffset = itemOffset + itemsPerPage;
    const currentItems = pageItems.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(pageItems.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % pageItems.length;
        setItemOffset(newOffset);
    };

    if (pageCount !== 0 && currentItems.length === 0) {
        let li_lenght = document.querySelectorAll('.pagination ul li').length
        document.querySelectorAll('.pagination ul li')[li_lenght - 2].previousSibling.className = 'selected'
        const data = {"selected": pageCount - 1}
        handlePageClick(data)
    }

    function toEdit(e) {
        e.currentTarget.blur()
        setOpen(true)
        const data = {
            "part": params['part'],
            "code": params['code'],
            "type": trackType
        }
        setOpenItem(data)
    }

    function toScan(e, track_code) {
        e.currentTarget.blur()
        setOpenScanNow(true)
        const data = {
            "track_code": track_code,
            "part": params['part'],
            "code": params['code'],
            "type": trackType
        }
        setOpenScanNowItem(data)
    }

    function getScanResult(code) {
        for (let i = 0; i < scanTrack.length; i++) {
            if (code == scanTrack[i]['code']) {
                return scanTrack[i]['uzb'].length
            }
        }
        return 0
    }

    function getNoScanResult(code) {
        for (let i = 0; i < scanTrack.length; i++) {
            if (code == scanTrack[i]['code']) {
                return scanTrack[i]['china'].length
            }
        }
        return 0
    }

    function getNoSendResult(code) {
        for (let i = 0; i < scanTrack.length; i++) {
            if (code == scanTrack[i]['code']) {
                console.log(scanTrack[i])
                return scanTrack[i]['ontheway'].length
            }
        }
        return 0
    }

    function goBack(e) {
        e.preventDefault()
        navigate('/documents/' + params['part']  + "/?" + trackType)
    }

    function sortScanned() {
        const strDescending = [...documents].sort((a, b) =>
            a.place > b.place ? -1 : 1,
        );
        setDocuments(strDescending)
    }

    function sortNotScanned() {
        const strAscending = [...documents].sort((a, b) =>
            a.place > b.place ? 1 : -1,
        );
        setDocuments(strAscending)
    }

    function formatDate(item) {
        if (!item.create_date) return '-'
        const d = new Date(item.create_date)
        if (isNaN(d)) return '-'
        const day   = String(d.getDate()).padStart(2, '0')
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const year  = d.getFullYear()
        return `${day}.${month}.${year}`
    }

    return <div>
        <div className={'page worker-page documents'}>
            {open ? <EditDocument setOpenItem={setOpenItem} openItem={openItem} open={open} setOpen={setOpen}/> : ''}
            {openScanNow ? <ScanDocument setOpenItem={setOpenScanNowItem} openItem={openScanNowItem} open={openScanNow}
                                         setOpen={setOpenScanNow}
                                         onScanned={(trackCode) => setScannedCodes(prev => new Set([...prev, trackCode]))}/> : ''}
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ArrowBackIcon/>} onClick={(e) => goBack(e)}>
                        Ortga
                    </Button>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>
                            {"Scan qilish"}
                            {trackType && <span className={`badge ms-2 ${
                                trackType === 'avia' ? 'bg-primary' :
                                    trackType === 'avia_tracking' ? 'bg-warning text-dark' :
                                        'bg-success'
                            }`}>
                                {trackType === 'avia' ? 'Avia' :
                                    trackType === 'avia_tracking' ? 'Avia Tracking' :
                                        'Fura'}
                            </span>}
                        </h2>
                        <p>
                            <h5 style={{cursor: "pointer"}} onClick={() => sortScanned()}>Scan
                                qilingan: {getScanResult(documents.length ? documents[0]['code'] : 0)}
                                {scannedCodes.size > 0 && <span style={{color: '#4caf50', marginLeft: '4px'}}>({scannedCodes.size})</span>}
                            </h5>
                            <h5 style={{cursor: "pointer"}} onClick={() => sortNotScanned()}>Scan
                                qilinmagan: {getNoScanResult(documents.length ? documents[0]['code'] : 0)}
                                {scannedCodes.size > 0 && <span style={{color: '#4caf50', marginLeft: '4px'}}>({scannedCodes.size})</span>}
                            </h5>
                            <h5 style={{cursor: "pointer"}} onClick={() => sortNotScanned()}>Yetkazib berilmoqda:
                                {getNoSendResult(documents.length ? documents[0]['code'] : 0)}
                                {scannedCodes.size > 0 && <span style={{color: '#4caf50', marginLeft: '4px'}}>({scannedCodes.size})</span>}
                            </h5>
                        </p>
                    </div>

                    {/* Payment Status and Delivery Info Cards */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} md={6}>
                            <PaymentStatusCard />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <DeliveryInfoCard />
                        </Grid>
                    </Grid>

                    <div className={'filter-block scan'}>
                        {notFound ? '' :
                            <Button variant="contained" title={"O'zgartirish"} color={"success"}
                                    endIcon={<DocumentScannerIcon/>}
                                    onClick={(e) => toEdit(e)}>Scan qilish</Button>}
                    </div>
                    {currentItems.length ? <table className="table table-hover table-responsive ">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">{"Buyurtma kodi"}</th>
                            <th scope="col">{"Partiya raqami"}</th>
                            <th scope="col">{"Trek kod"}</th>
                            <th scope="col">{"Sana"}</th>
                            <th scope="col">{"Joylashgan joyi"}</th>
                            {trackType && <th scope="col">{"Turi"}</th>}
                            {notFound ? '' : <th scope="col">{"Scan qilish"}</th>}
                        </tr>
                        </thead>
                        <tbody>
                        {currentItems.length ? currentItems.map((item, index) => <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{item.code}</td>
                                <td>{item.serial_number}</td>
                                <td>
                                    {item.track_code}
                                    {scannedCodes.has(item.track_code) && (
                                        <CheckCircleIcon
                                            style={{color: '#4caf50', marginLeft: '6px', verticalAlign: 'middle', fontSize: '18px'}}
                                        />
                                    )}
                                </td>
                                <td>{formatDate(item)}</td>

                                <td>
                                    {item.place === 'ontheway' ? (
                                        "Yetkazib berilmoqda"
                                    ) : (
                                        <>
                                            <img
                                                src={item.place === 'uzb' ? uzb_flag : china_flag}
                                                className="flag d-inline"
                                                alt="Flag"
                                            />
                                            {item.place === 'uzb' ? "O'zbekiston" : "Xitoy"}
                                        </>
                                    )}
                                </td>
                                {trackType && <td>
                                    <span className={`badge ${
                                        trackType === 'avia' ? 'bg-primary' :
                                            trackType === 'avia_tracking' ? 'bg-warning text-dark' :
                                                'bg-success'
                                    }`}>
                                        {trackType === 'avia' ? 'Avia' :
                                            trackType === 'avia_tracking' ? 'Avia Tracking' :
                                                'Fura'}
                                    </span>
                                </td>}
                                {notFound || item.place === 'uzb' ? '' :
                                    <td><Button variant="contained" title={"O'zgartirish"} color={"success"}
                                                endIcon={<DocumentScannerIcon/>}
                                                onClick={(e) => toScan(e, item.track_code)}/></td>}
                            </tr>)
                            :
                            ''
                        }
                        </tbody>
                    </table> : ''}
                    {pageCount > 1 ? <div className={'pagination'}>
                        <ReactPaginate
                            breakLabel="..."
                            nextLabel={<KeyboardArrowRightIcon/>}
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={5}
                            pageCount={pageCount}
                            previousLabel={<KeyboardArrowLeftIcon/>}
                            renderOnZeroPageCount={null}
                        />
                    </div> : ''}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.documents, {getAlLThis, getAllVerifyResponse})(OneDoc)